import { useCan } from "./useCan";
import { useFeatureFlags } from "../tenant/features/useFeatureFlag";

export interface MenuAccessSpec {
  /** Tenant feature flag gating this item (skipped when omitted). */
  flag?: string;
  /** User permission gating this item (skipped when omitted). */
  permission?: number;
}

/**
 * Returns a predicate deciding whether a menu item is visible, using the SAME rule
 * as the page-level route guards: the item's feature flag must be enabled for the
 * tenant AND the user must have its permission. Either field may be omitted — that
 * condition is then skipped. Sourcing flag/permission from the same constants the
 * routes use keeps nav visibility and route access from drifting apart.
 */
export function useCanSeeMenuItem() {
  const { isEnabled } = useFeatureFlags();
  const { can } = useCan();
  return (item: MenuAccessSpec): boolean =>
    (!item.flag || isEnabled(item.flag)) && (!item.permission || can(item.permission));
}
